/**
 * Class to work as a DTO to hold the information of a event dispatched the speedcurve timing metric.
 */
class SpeedcurveTimingMetric {
  constructor(name, value) {
    this.name = name;
    this.value = value;
  }

  /**
   * The function returns the value of the name property.
   * @returns The value of the variable `name`.
   */
  getName() {
    return this.name;
  }

  /**
   * The function returns the value of the "value" property.
   * @returns The `value` property is being returned.
   */
  getValue() {
    return this.value;
  }
}

export default SpeedcurveTimingMetric;
